/** Courts whose judgments SierraLII publishes (ADR-018), by neutral-citation code. */
export const COURT_NAMES: Record<string, string> = {
  SLSC: 'Supreme Court of Sierra Leone',
  SLCA: 'Court of Appeal of Sierra Leone',
  SLHC: 'High Court of Sierra Leone',
  SLHCCRD: 'High Court — Criminal Division',
  SLHCFPD: 'High Court — Family and Probate Division',
  SLHCFTCAD: 'High Court — Fast Track Commercial and Admiralty Division',
  SLHCGD: 'High Court — General Civil Division',
  SLHCISSD: 'High Court — Industrial and Social Security Division',
  SLHCLPED: 'High Court — Land, Property and Environment Division',
  SLHCSOD: 'High Court — Sexual Offences Division',
  SCSL: 'Special Court for Sierra Leone',
};

/** Highest courts first, then the High Court and its divisions. */
export const COURT_ORDER = Object.keys(COURT_NAMES).sort(
  (a, b) => rank(a) - rank(b) || a.localeCompare(b),
);

function rank(code: string): number {
  if (code === 'SLSC') return 0;
  if (code === 'SLCA') return 1;
  if (code === 'SLHC') return 2;
  if (code.startsWith('SLHC')) return 3;
  return 4;
}
